import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  private responseDataSubject = new BehaviorSubject<any>(this.loadResponseData());
  private exploreModeApiUrl = 'https://dev-dexcat.alpha.simadvisory.com/v1/dexcat/explore-mode/inbound'; // API for Explore Mode

  constructor(private http: HttpClient) {}

  uploadFiles(formData: FormData): Observable<any> {
    return this.http.post<any>(this.exploreModeApiUrl+'/dashboard', formData);
  }

  setResponseData(data: any) {
    this.responseDataSubject.next(data);
    localStorage.setItem('exploreModeData', JSON.stringify(data)); // Store in localStorage
  }

  getResponseData(): Observable<any> {
    return this.responseDataSubject.asObservable();
  }
  getUpdatedDashboard(data:any): Observable<any> {
    return this.http.post<any>(this.exploreModeApiUrl+'/overide-recommendation', data);
  }
  private loadResponseData(): any {
    const storedData = localStorage.getItem('exploreModeData');
    return storedData ? JSON.parse(storedData) : null;
  }
}

